module.exports = __webpack_public_path__ + "static/media/googleRound.04b5a896.svg";